import {
  ABOUT_US,
  USER_ZONE,
  SEARCH_MASSAGE,
  SIGN_IN,
  SIGN_UP,
  SERVICE_TERMS,
  PRIVACY_POLICY,
  MASSAGE_MASTER_ZONE,
} from "constants/routes";
import LinksColumn from "./LinksColumn/LinksColumn";
import classes from "./LinksSection.module.css";
import useTranslation from "next-translate/useTranslation";

const serviceLinks = [
  { href: ABOUT_US, text: "about_us" },
  { href: SERVICE_TERMS, text: "terms_of_use" },
  { href: PRIVACY_POLICY, text: "privacy_policy" },
];

const forPatientsLinks = [
  { href: SEARCH_MASSAGE, text: "search_massage_therapists" },
];

const forProfessionalsLinks = [
  { href: MASSAGE_MASTER_ZONE, text: "massage_therapist_area" },
  { href: SIGN_IN, text: "log_in" },
  { href: SIGN_UP, text: "sign_up" },
];

const LinksSection = () => {
  const { t } = useTranslation("common");

  return (
    <div className={classes.linksSection}>
      <LinksColumn heading={t("service")} links={serviceLinks} />
      <LinksColumn heading={t("for_clients")} links={forPatientsLinks} />
      <LinksColumn
        heading={t("for_professionals")}
        links={forProfessionalsLinks}
      />
    </div>
  );
};

export default LinksSection;
